import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const navItems = [
  { label: '首页', path: '/' },
  { label: '软件下载', path: '/softwares' },
  { label: '关于我们', path: '/about' },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const [keyword, setKeyword] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setMenuOpen(false);
  };

  const isActive = (path: string) =>
    path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);

  return (
    <header className="sticky top-0 z-50 bg-secondary-950 text-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center h-16 gap-4">
          <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
            <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-secondary-950">
              <i className="ri-vip-diamond-line text-xl" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading font-bold text-base md:text-lg text-primary-400 whitespace-nowrap">
                黄金软件下载站
              </span>
              <span className="text-[10px] text-background-300 tracking-wide hidden sm:block">
                黄金网站软件app免费
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1 ml-4">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-3 py-2 rounded-md text-sm whitespace-nowrap cursor-pointer transition-colors ${
                  isActive(item.path)
                    ? 'bg-primary-500 text-secondary-950 font-medium'
                    : 'text-background-200 hover:bg-secondary-800 hover:text-background-50'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <form onSubmit={submitSearch} className="hidden md:flex flex-1 max-w-md ml-auto">
            <div className="relative w-full">
              <span className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center text-background-400">
                <i className="ri-search-line text-base" />
              </span>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索黄金投资软件、行情APP"
                className="w-full h-10 pl-9 pr-3 rounded-md bg-secondary-900 border border-secondary-700 text-sm text-background-50 placeholder:text-background-400 outline-none focus:border-primary-500 transition-colors"
              />
            </div>
            <button
              type="submit"
              className="ml-2 h-10 px-4 rounded-md bg-primary-500 hover:bg-primary-600 text-secondary-950 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors"
            >
              搜索
            </button>
          </form>

          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden ml-auto w-10 h-10 rounded-md bg-secondary-900 flex items-center justify-center cursor-pointer"
            aria-label="打开菜单"
          >
            <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-secondary-800 bg-secondary-950 px-4 pb-4">
          <form onSubmit={submitSearch} className="flex gap-2 py-3">
            <div className="relative flex-1">
              <span className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center text-background-400">
                <i className="ri-search-line text-base" />
              </span>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索软件"
                className="w-full h-10 pl-9 pr-3 rounded-md bg-secondary-900 border border-secondary-700 text-sm text-background-50 placeholder:text-background-400 outline-none focus:border-primary-500"
              />
            </div>
            <button
              type="submit"
              className="h-10 px-4 rounded-md bg-primary-500 text-secondary-950 text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              搜索
            </button>
          </form>
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setMenuOpen(false)}
                className={`px-3 py-2 rounded-md text-sm cursor-pointer ${
                  isActive(item.path)
                    ? 'bg-primary-500 text-secondary-950 font-medium'
                    : 'text-background-200 hover:bg-secondary-800'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <div className="mt-2 pt-3 border-t border-secondary-800">
              <p className="px-3 pb-2 text-xs text-background-400">软件分类</p>
              <div className="grid grid-cols-2 gap-1">
                {categories.map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.id}`}
                    onClick={() => setMenuOpen(false)}
                    className="px-3 py-2 rounded-md text-sm text-background-200 hover:bg-secondary-800 cursor-pointer flex items-center gap-2"
                  >
                    <span className="w-4 h-4 flex items-center justify-center text-primary-400">
                      <i className={`${cat.icon} text-base`} />
                    </span>
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}